module.exports = __webpack_public_path__ + "assets/imgs/background.v1.png";